import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { TenantNotificationService } from '@jms/utils/util.notifications';
import { ApplicationActions } from '@jms/tenant/module.jms.state';
import { DomainUtility, UserType } from '@jms/model';
import { CurrentUserService } from '@jms/ui/ui.standalone.services/current.user.service';


@Component({
  selector: 'shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ShellComponent implements OnInit, OnDestroy {

  private _stateSubscription: Subscription;
  public state: any;

  public showFeed = false;
  public environment = ConfigService.environment;
  public friendlyEnvironment = DomainUtility.getFriendlyEnvironment(this.environment.environment as any);
  public buildVersion = this.environment.build === 'undefined-undefined' ? 'Dev Version' : this.environment.build;
  public accountUrl: string;
  public isSuperUserAndProduction = (this.currentUserService.role.type === UserType.SystemAdministrator) && this.environment.production;
  protected $preventLogin = ConfigService.$preventLogin;

  public menuItems = [
    { label: 'View Profile', icon: 'fa fa-user', command: () => { window.open(this.accountUrl, '_blank') } },
    { label: '-', separator: true },
    { label: 'Log Off', icon: 'fa fa-sign-out', command: () => this.actions.logout(true) },
  ]


  @HostBinding('attr.id') shellId = 'shell';

  constructor(
    public actions: ApplicationActions,
    private cdr: ChangeDetectorRef,
    private tenantNotifications: TenantNotificationService,
    private currentUserService: CurrentUserService,
  ) {

  }

  async ngOnInit() {

    this._stateSubscription = this.actions.state$
      .subscribe(state => {
        this.state = state;
      });

    this.tenantNotifications.tenant$
      .subscribe(tenantData => {
      });

    this.tenantNotifications.user$
      .subscribe(userData => {
      });



    this.accountUrl = `${this.environment.jms.loginHref}/account`;
  }

  ngOnDestroy() {
    this._stateSubscription.unsubscribe();
  }

  public prepareAnimations(outlet: RouterOutlet) {
    return outlet.activatedRoute.url;
  }

}
